import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-2',
  templateUrl: './2.component.html',
  styleUrls: ['./2.component.scss'],
})
export class VbList2Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
